module.exports = __webpack_public_path__ + "0276f7e4.svg";